var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogbook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ffd600",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16 4v8l-3-2-3 2v-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 4v22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 4h-15v22h15c1.657 0 3-1.343 3-3v-16c0-1.657-1.343-3-3-3z",
    strokeLinecap: "square"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogbook);
export default __webpack_public_path__ + "static/media/logbook.a3df634482c7e05a075bea405f6cdc4e.svg";
export { ForwardRef as ReactComponent };